module.exports = __webpack_public_path__ + "static/media/HOT.bede5cb4.svg";